import { render } from "./AdminOnboarding.vue?vue&type=template&id=771d1e3c&scoped=true&ts=true"
import script from "./AdminOnboarding.vue?vue&type=script&lang=ts"
export * from "./AdminOnboarding.vue?vue&type=script&lang=ts"

import "./AdminOnboarding.vue?vue&type=style&index=0&id=771d1e3c&scoped=true&lang=css"

import exportComponent from "../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771d1e3c"]])

export default __exports__